import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { X, Gift, ArrowRight } from "lucide-react";

export default function PromoBanner() {
    const [open, setOpen] = useState(true);
    useEffect(() => {
        try {
            if (sessionStorage.getItem("shh-banner-closed")) setOpen(false);
        } catch (_) {}
    }, []);
    if (!open) return null;
    const close = () => {
        setOpen(false);
        try { sessionStorage.setItem("shh-banner-closed", "1"); } catch (_) {}
    };
    return (
        <div data-testid="promo-banner" className="bg-primary text-primary-foreground">
            <div className="container-editorial py-2.5 flex items-center gap-3">
                <Gift className="h-4 w-4 text-accent shrink-0" />
                <p className="text-xs sm:text-sm flex-1 truncate">
                    <span className="font-semibold">Free eBook:</span>{" "}
                    <span className="hidden sm:inline">"25 Online Income Ideas for Beginners in 2026" — </span>
                    <Link data-testid="promo-banner-link" to="/ebooks" className="underline underline-offset-4 hover:text-accent">
                        Download now <ArrowRight className="h-3 w-3 inline" />
                    </Link>
                </p>
                <button
                    data-testid="promo-banner-close"
                    onClick={close}
                    aria-label="Close promo"
                    className="p-1 rounded-full hover:bg-white/10 transition"
                >
                    <X className="h-4 w-4" />
                </button>
            </div>
        </div>
    );
}
